import axiosInstance from "../../../axios";

export const getRoi = async (param) => {
  console.log("REceiveing in final api :", param);
  const url=`/roi/batch-analytics?month=${param?.month}&year=${param?.year}&keyword=${param?.search}&pageNo=${param?.page}&pageLength=${param?.limit} `;
  try {
    const {data} = await axiosInstance.get(url);
    return{ data: data?.payload}
  } catch (error) {
    return {error:error}
    // throw error;
  }
};


export const getDownloadRoi = async (param) => {
  console.log("ROI Obj ", param);
  const {startMonth,endMonth,startYear,endYear}=param;
  // &pageNo=${param?.pageNo}&pageLength=${param?.limit}&courseId=${param?.courseId}
  const url=`/roi/download/batch-analytics?endYear=${endYear}&endMonth=${endMonth}&startYear=${startYear}&startMonth=${startMonth}`;
  try {

    const {data,error} = await axiosInstance.get(url);
    console.log("API DATA::", data);
    if(data?.success)
    {
      return{ data: data?.payload}
    }
  } catch (error) {
      return {error:error}
  }
};

export const getCourseRoi = async (param) => {
    console.log("ROI Obj ", param);
    try {

      const {data} = await axiosInstance.get(`/roi/course-analytics?month=${param?.month}&year=${param?.year}`);
      console.log(
        "Response data inside the get COURSE ROI service : -> ",data
      );
      return{ data: data?.payload}
    } catch (error) {
      console.error("Error in get ROI service:", error);
      throw error;
    }
  };




